import { z } from 'zod';

export const Domain = z.string().refine(
  (value) => {
    // Validate the value is a valid domain name
    return /^(?:(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|localhost)(:\d{4})?$/i.test(
      value,
    );
  },
  () => ({
    message: 'Domain is not valid',
  }),
);

export type Domain = z.infer<typeof Domain>;
